var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.$t("subtitle")))]),
      _vm._v(" "),
      _vm.loading
        ? _c("gs1-alert-loading", { staticStyle: { "margin-top": "30px" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.searchTermErrors.length > 0
        ? _c("gs1-alert-search-term-errors", {
            staticStyle: { "margin-top": "30px" },
            attrs: { ids: _vm.searchTermErrors }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { "margin-top": "60px", "margin-bottom": "10px" }
        },
        [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "form",
                {
                  staticClass: "form-inline",
                  staticStyle: { "margin-left": "15px" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.completeOnly,
                              expression: "completeOnly"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.completeOnly)
                              ? _vm._i(_vm.completeOnly, null) > -1
                              : _vm.completeOnly
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.completeOnly,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.completeOnly = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.completeOnly = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.completeOnly = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("only_complete")) +
                            "\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group form-search-box" }, [
                    _c("div", { staticClass: "input-wrapper icon-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          name: "search",
                          placeholder: _vm.$t("search")
                        },
                        domProps: { value: _vm.search },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "auto",
                    "margin-right": "15px",
                    position: "relative",
                    bottom: "10px"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      staticStyle: { "margin-right": "10px" },
                      attrs: { disabled: !_vm.canExport, type: "button" },
                      on: {
                        click: function($event) {
                          _vm.exportResults("csv")
                        }
                      }
                    },
                    [_vm._v("CSV\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: { disabled: !_vm.canExport, type: "button" },
                      on: {
                        click: function($event) {
                          _vm.exportResults("xlsx")
                        }
                      }
                    },
                    [_vm._v("XLSX\n          ")]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", { staticClass: "table table-bordered table-striped" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", { staticStyle: { "border-right": "none" } }),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticStyle: { "border-left": "none", "font-weight": "bold" }
                },
                [_vm._v(_vm._s(_vm.$t("product_info")))]
              ),
              _vm._v(" "),
              _c("th", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.$t("gtin")))
              ])
            ])
          ]),
          _vm._v(" "),
          typeof _vm.filteredGTINResults !== "undefined" &&
          _vm.filteredGTINResults.length > 0
            ? _c(
                "tbody",
                _vm._l(_vm.filteredGTINResults, function(result, i) {
                  return _c(
                    "tr",
                    {
                      key: i,
                      class: {
                        error: result.error && result.error.code === "NOT_FOUND"
                      }
                    },
                    [
                      result.error
                        ? _c("td", { staticClass: "image" }, [
                            _c("img", {
                              staticClass: "img-responsive",
                              attrs: { src: "/static/images/unknown.png" }
                            })
                          ])
                        : _c(
                            "td",
                            { staticClass: "image" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Result",
                                      params: { search: result.gtin },
                                      query: { bulk: null }
                                    }
                                  }
                                },
                                [
                                  typeof result.productImageUrl !==
                                    "undefinded" &&
                                  Array.isArray(result.productImageUrl) &&
                                  result.productImageUrl.length > 0
                                    ? _c("img", {
                                        staticClass: "img-responsive",
                                        attrs: {
                                          src: result.productImageUrl[0].value
                                        }
                                      })
                                    : _c("img", {
                                        staticClass: "img-responsive",
                                        attrs: {
                                          src: "/static/images/unknown.png"
                                        }
                                      })
                                ]
                              )
                            ],
                            1
                          ),
                      _vm._v(" "),
                      result.error
                        ? _c(
                            "td",
                            { staticClass: "description" },
                            [
                              result.error.code === "NOT_FOUND"
                                ? _c(
                                    "i18n",
                                    {
                                      attrs: {
                                        path: "errors.NOT_FOUND",
                                        tag: "strong"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "https://www.gs1-germany.de/service/kontakt/",
                                            target: "_blank",
                                            rel: "noopener"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("contact_gs1")) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : result.error.code === "REGISTERED"
                                ? _c(
                                    "i18n",
                                    {
                                      attrs: {
                                        path: "errors.REGISTERED",
                                        tag: "strong"
                                      }
                                    },
                                    [
                                      _c(
                                        "b",
                                        {
                                          staticStyle: {
                                            color: "var(--gs1-blue)"
                                          }
                                        },
                                        [_vm._v(_vm._s(result.licenseeName))]
                                      )
                                    ]
                                  )
                                : _c(
                                    "i18n",
                                    {
                                      attrs: {
                                        path: "errors." + result.error.code,
                                        tag: "strong"
                                      }
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "Result",
                                              params: {
                                                search: result.error.suggestion,
                                                bulk: "yes"
                                              },
                                              query: { bulk: null }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(result.error.suggestion) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _c("td", { staticClass: "description" }, [
                            result.productDescription
                              ? _c(
                                  "div",
                                  _vm._l(result.productDescription, function(
                                    description
                                  ) {
                                    return _c(
                                      "router-link",
                                      {
                                        key: description.language,
                                        attrs: {
                                          to: {
                                            name: "Result",
                                            params: { search: result.gtin },
                                            query: { bulk: null }
                                          }
                                        }
                                      },
                                      [
                                        _c("lang-string", {
                                          attrs: {
                                            lang: description.language,
                                            value: description.value
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  })
                                )
                              : result.productDescription
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "i18n",
                                      { attrs: { path: "registered_to" } },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(result.licenseeName) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("nothing_found")) +
                                      "\n            "
                                  )
                                ])
                          ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "gtin" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "Result",
                                  params: { search: result.gtin },
                                  query: { bulk: null }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(result.gtin) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                })
              )
            : _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center text-muted",
                      attrs: { colspan: "3" }
                    },
                    [_vm._v(_vm._s(_vm.$t("no_data")))]
                  )
                ])
              ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", { staticStyle: { "border-right": "none" } }),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticStyle: { "border-left": "none", "font-weight": "bold" }
                },
                [_vm._v(_vm._s(_vm.$t("location_info")))]
              ),
              _vm._v(" "),
              _c("th", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.$t("gln")))
              ])
            ])
          ]),
          _vm._v(" "),
          typeof _vm.filteredGLNResults !== "undefined" &&
          _vm.filteredGLNResults.length > 0
            ? _c(
                "tbody",
                _vm._l(_vm.filteredGLNResults, function(result, i) {
                  return _c(
                    "tr",
                    {
                      key: i,
                      class: {
                        error: result.error && result.error.code === "NOT_FOUND"
                      }
                    },
                    [
                      _c("td", { staticStyle: { "border-right": "none" } }),
                      _vm._v(" "),
                      result.error
                        ? _c(
                            "td",
                            { staticClass: "description" },
                            [
                              result.error.code === "NOT_FOUND"
                                ? _c(
                                    "i18n",
                                    {
                                      attrs: {
                                        path: "errors.NOT_FOUND",
                                        tag: "strong"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "https://www.gs1-germany.de/service/kontakt/",
                                            target: "_blank",
                                            rel: "noopener"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("contact_gs1")) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : result.error.code === "REGISTERED"
                                ? _c(
                                    "i18n",
                                    {
                                      attrs: {
                                        path: "errors.REGISTERED",
                                        tag: "strong"
                                      }
                                    },
                                    [
                                      _c(
                                        "b",
                                        {
                                          staticStyle: {
                                            color: "var(--gs1-blue)"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              result.gs1Licence.licenseeName
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "i18n",
                                    {
                                      attrs: {
                                        path: "errors." + result.error.code,
                                        tag: "strong"
                                      }
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "Result",
                                              params: {
                                                search: result.error.suggestion,
                                                bulk: "yes"
                                              },
                                              query: { bulk: null }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(result.error.suggestion) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _c(
                            "td",
                            {
                              staticClass: "description",
                              staticStyle: { "border-left": "none" }
                            },
                            [
                              result.gs1Licence.licenseeName
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "i18n",
                                        {
                                          attrs: { path: "registered_to_gln" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "Result",
                                                  params: {
                                                    search: result.gln
                                                  },
                                                  query: { bulk: null }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    result.gs1Licence
                                                      .licenseeName
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : result.gs1Licence.licenseeName
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "i18n",
                                        { attrs: { path: "registered_to" } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                result.gs1Licence.licenseeName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("nothing_found")) +
                                        "\n            "
                                    )
                                  ])
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "gtin" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "Result",
                                  params: { search: result.gln },
                                  query: { bulk: null }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(result.gln) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                })
              )
            : _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center text-muted",
                      attrs: { colspan: "3" }
                    },
                    [_vm._v(_vm._s(_vm.$t("no_data")))]
                  )
                ])
              ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "65px" } }),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "thead",
      {
        staticStyle: {
          "border-right": "1px solid #fbfbfb",
          "border-left": "1px solid #fbfbfb"
        }
      },
      [
        _c("tr", [
          _c("th", {
            staticStyle: { "border-left": "none", "border-right": "none" }
          }),
          _vm._v(" "),
          _c("th", {
            staticStyle: { "border-left": "none", "border-right": "none" }
          }),
          _vm._v(" "),
          _c("th", {
            staticStyle: { "border-left": "none", "border-right": "none" }
          })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73a65670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a65670","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/Results.vue
// module id = null
// module chunks = 